export const CommonMessages = {

  NonEmptyField: "Não pode estar vazio",
  InvalidEmail: "Email inválido",
  Error: "Erro",
  Alert: "Alerta",
  Success: "Sucesso!",

  ErroGenerico: "Erro ao acessar serviços, procure o administrador do sistema.",
  LimiteMinimoPesquisa: "O termo buscado deve conter pelo menos três caracteres entre letras e números.",

  Autenticidade: {
    Titulo: 'Verificação de',
    TituloDestaque: 'autenticidade',
    Descricao: 'Para confirmar a autenticidade de uma publicação do Jornal Minas Gerais, insira o código de verificação localizado no rodapé da página que deseja validar.',
    InformeCodigo: 'Insira o código de verificação*:',
    PlaceholderCodigo: 'Digite aqui o código',
    BotaoVerificar: 'Verificar',
    ValidandoCodigo: 'Validando código de autenticidade...',
    OndeEncontrar: 'Onde encontrar:',
    APartirDeSetembro2026: 'A partir de Setembro de 2026:',
    InstrucaoPublicacaoHtml: 'No lado direito, logo acima do conteúdo da matéria, como na imagem de exemplo abaixo:',
    DescricaoPublicacaoHtml: 'Código de autenticidade no lado direito, acima do conteúdo de uma publicação HTML',
    DeMarco2019AAgosto2026: 'De Março de 2019 a Agosto de 2026:',
    InstrucaoPdf: 'No rodapé das páginas do jornal, dentro do PDF, como na imagem de exemplo abaixo:',
    DescricaoPdf: 'Rodapé página jornal',
    SobreCodigo: 'Sobre o código:',
    DescricaoCodigo: 'Os documentos assinados eletronicamente estão em conformidade com o artigo 6º do decreto n.º 47.222, de 26 de julho de 2017.'
  },

  EdicaoHtml: {
    CarregarUltimaEdicao: 'Não foi possível carregar a edição.',
    CarregarEdicaoPorData: 'Não foi possível carregar a edição desta data.',
    CarregarMaterias: 'Não foi possível carregar as matérias.',
    BaixarCadernoEdicaoErro: 'Não foi possível baixar o jornal neste momento. Por favor, tente novamente em alguns instantes.',
    BaixarMateriaPublicadaErro: 'Não foi possível baixar a publicação neste momento. Por favor, tente novamente em alguns instantes.',
    SemEdicaoTitulo: 'Não foi localizada edição do Jornal Minas Gerais para a data selecionada!',
    SemEdicaoPeriodoAtualDestaque: 'Caso a pesquisa seja relativa ao período de 01/01/1999 até os dias atuais,',
    SemEdicaoPeriodoAtual: 'verifique se a data escolhida é um domingo, segunda-feira ou um feriado/ponto facultativo.',
    SemEdicaoPublicacao: 'Ressaltamos que não há publicação do Jornal Minas Gerais no dia seguinte a um feriado/ponto facultativo. Também lembramos que as edições são publicadas de terça-feira a sábado.',
    SemEdicaoDigitalizacaoDestaque: 'Caso a pesquisa seja referente ao período de 23/08/1943 a 31/12/1998,',
    SemEdicaoDigitalizacao: 'a edição pesquisada se encontra em processo de digitalização, para posterior disponibilização neste site.',
    SemEdicaoAtendimento: 'Em caso de dúvidas, sugestões e reclamações entre em contato conosco pelos nossos canais de atendimento.'
  }
}
